export const finance = {
  "finance.priceList.loading": "Loading the price list",
  "finance.priceList.forbidden": "You may not read the clinic price list.",
  "finance.priceList.actions": "Actions",
  "finance.priceLists.subtitle": "Named lists of what the Clinic charges; a service's price lands in the default list.",
  "finance.priceLists.tableLabel": "Price lists",
  "finance.priceLists.column.name": "Price list",
  "finance.priceLists.column.default": "Default",
  "finance.priceLists.column.branches": "Branches",
  "finance.priceLists.column.state": "State",
  "finance.priceLists.defaultBadge": "Default list",
  "finance.priceLists.wholeClinic": "Whole Clinic",
  "finance.priceLists.active": "Active",
  "finance.priceLists.archived": "Archived",
  "finance.priceLists.openNamed": "Settings of {name}",
  "finance.priceLists.makeDefaultNamed": "Make {name} the default list",
  "finance.priceLists.madeDefault": "{name} is now the default list.",
  "finance.priceLists.loadFailed": "The price lists could not be loaded.",
  "finance.priceLists.empty": "No price lists",
  "finance.priceLists.emptyDetail": "Add a price list, or record a service's first price under Services: the Clinic default list appears with it.",
  "finance.priceLists.emptyDetailReader": "No price list has been created yet.",
  "finance.priceLists.readOnly": "You may read the price lists; changing them needs the price list management grant.",
  "finance.priceList.title": "Price list",
  "finance.priceList.new": "New price list",
  "finance.priceList.name": "Name",
  "finance.priceList.branches": "Branches",
  "finance.priceList.branchesHint": "No branch ticked: the list serves the whole Clinic.",
  "finance.priceList.isDefault": "Default list",
  "finance.priceList.isDefaultHint": "A new service's price lands here, and a price asked without a list is read from here.",
  "finance.priceList.isDefaultLocked": "The default list stays the default until another list takes its place.",
  "finance.priceList.firstIsDefault": "The first price list of the Clinic becomes its default.",
  "finance.priceList.save": "Save",
  "finance.priceList.active": "Active",
  "finance.priceList.archived": "Archived",
  "finance.priceList.archive": "Archive",
  "finance.priceList.archiveTitle": "Archive this price list?",
  "finance.priceList.archiveDescription": "The list stops pricing new work. Prices already pinned by documents stay as they were.",
  "finance.priceList.archiveConfirm": "Archive the list",
  "finance.priceList.keepList": "Keep the list",
  "finance.priceList.archiveLocked": "Choose another default list before archiving this one.",
  "finance.priceList.archiveDirty": "Save or discard the changes before archiving.",
  "finance.priceList.archivedNote": "This list is archived: its prices stay for the documents that pinned them and cannot change.",
  "finance.priceList.unsaved": "Unsaved price list",
  "finance.priceList.discard": "Discard changes",
  "finance.priceList.reloadDiscard": "Reload and discard changes",
  "finance.priceList.saveFailed": "The price list could not be saved.",
  "finance.priceList.changed": "The price list changed since you opened it. Reload before saving.",
  "finance.priceList.invalid": "The price list was refused. Check the name and the branches.",
  "finance.priceList.notFound": "This price list no longer exists.",
  "finance.priceList.archivedRefusal": "This price list is archived and cannot change.",
  "finance.priceList.defaultRequired": "Choose another default list first: the default list is neither archived nor demoted.",
  "finance.priceList.loadFailed": "The price list could not be loaded.",
  "finance.priceList.pricesLoadFailed": "The prices could not be loaded.",
  "finance.priceList.edit": "Edit the price list",
  "finance.priceList.tabs": "Price list sections",
  "finance.priceList.pricesTab": "Prices",
  "finance.priceList.packagesTab": "Packages",
  "finance.priceList.onDate": "Prices on",
  "finance.priceList.branch": "Seen from",
  "finance.priceList.servicesLabel": "Services priced in {name}",
  "finance.priceList.column.service": "Service",
  "finance.priceList.column.price": "Price",
  "finance.priceList.column.tax": "Tax",
  "finance.priceList.column.from": "From",
  "finance.priceList.column.until": "Until",
  "finance.priceList.column.scope": "Applies to",
  "finance.priceList.column.state": "Service state",
  "finance.priceList.setPriceNamed": "Set the price of {name}",
  "finance.priceList.openPriceNamed": "Prices of {name}",
  "finance.priceList.servicesEmpty": "No services",
  "finance.priceList.servicesEmptyDetail": "Create services under Services; they appear here to be priced.",
  "finance.priceRow.title": "Price",
  "finance.priceRow.inList": "In {list}",
  "finance.priceRow.current": "On {date}: {price}, {scope}",
  "finance.priceRow.currentNone": "No price on {date}",
  "finance.priceRow.amount": "New price, {currency}",
  "finance.priceRow.amountRequired": "Enter the price.",
  "finance.priceRow.scope": "Applies to",
  "finance.priceRow.from": "From",
  "finance.priceRow.fromRequired": "Enter the first day the price applies.",
  "finance.priceRow.until": "Until, optional",
  "finance.priceRow.untilHint": "The first day the price no longer applies; empty keeps it open-ended.",
  "finance.priceRow.untilInvalid": "The last day must come after the first.",
  "finance.priceRow.save": "Record the price",
  "finance.priceRow.discard": "Discard",
  "finance.priceRow.unsaved": "Unrecorded price",
  "finance.priceRow.serviceArchived": "This service is archived; its prices are kept but no new one can be recorded.",
  "finance.priceRow.saveFailed": "The price could not be recorded.",
  "finance.priceRow.invalid": "The price was refused. Check the amount and the dates.",
  "finance.pricePackage.title": "Package",
  "finance.pricePackage.new": "New package",
  "finance.pricePackage.name": "Name",
  "finance.pricePackage.lines": "Services in the package",
  "finance.pricePackage.service": "Service",
  "finance.pricePackage.chooseService": "Choose a service",
  "finance.pricePackage.quantity": "Units",
  "finance.pricePackage.addLine": "Add a service",
  "finance.pricePackage.allAdded": "Every priced service of the list is already in the package.",
  "finance.pricePackage.removeLine": "Remove line {position}",
  "finance.pricePackage.linesRequired": "Name at least one priced service with its units.",
  "finance.pricePackage.nonePriced": "No service is priced in this list yet; a package names only priced services.",
  "finance.pricePackage.save": "Record the package",
  "finance.pricePackage.discard": "Discard",
  "finance.pricePackage.unsaved": "Unrecorded package",
  "finance.pricePackage.saveFailed": "The package could not be recorded.",
  "finance.pricePackage.invalid": "The package was refused. Check the dates, the services and the adjustments.",
  "finance.pricePackage.tableLabel": "Packages of {name}",
  "finance.pricePackage.column.name": "Package",
  "finance.pricePackage.column.lines": "Services",
  "finance.pricePackage.column.state": "State",
  "finance.pricePackage.line": "{name} × {quantity}",
  "finance.pricePackage.empty": "No packages",
  "finance.pricePackage.emptyDetail": "A package bundles priced services of this list for prepaid purchase.",
  "finance.pricePackage.retractNamed": "Retract {name}",
  "finance.pricePackage.retractTitle": "Retract this package?",
  "finance.pricePackage.retractDescription": "{name} will no longer be offered. Purchases already made from it keep their evidence.",
  "finance.pricePackage.retractConfirm": "Retract",
  "finance.pricePackage.keep": "Keep the package",
  "finance.pricePackage.retractFailed": "The package could not be retracted.",

  "finance.services.title": "Performed services",
  "finance.services.subtitle":
    "Services confirmed for this EMR record and their frozen charges.",
  "finance.services.loading": "Loading performed services",
  "finance.services.loadFailed": "Performed services could not be loaded.",
  "finance.services.tableLabel": "Performed services for this EMR record",
  "finance.services.empty": "No services recorded",
  "finance.services.emptyDetail":
    "Confirmed services for this record will appear here.",
  "finance.services.noMatches": "No services match these filters",
  "finance.services.noMatchesDetail":
    "Widen or clear the column filters to return to all performed services.",
  "finance.services.column.service": "Service",
  "finance.services.column.code": "Code",
  "finance.services.column.quantity": "Quantity",
  "finance.services.column.charge": "Charge",
  "finance.services.column.performed": "Recorded",
  "finance.services.column.serviceDate": "Service date",
  "finance.serviceCorrection.action": "Correct {name}",
  "finance.serviceCorrection.title": "Correct performed service",
  "finance.serviceCorrection.units": "Original units to reverse",
  "finance.serviceCorrection.unit": "Unit {number}",
  "finance.serviceCorrection.correctedUnit": "Unit {number} (already reversed)",
  "finance.serviceCorrection.reason": "Reason",
  "finance.serviceCorrection.remaining": "Quantity after correction",
  "finance.serviceCorrection.postingDate": "Correction posting date",
  "finance.serviceCorrection.portion": "Responsibility {number}",
  "finance.serviceCorrection.credit": "Credit",
  "finance.serviceCorrection.release": "Allocation release required",
  "finance.serviceCorrection.payment": "Release from payment dated {date}",
  "finance.serviceCorrection.available": "Available to release: {amount}",
  "finance.serviceCorrection.noPayout": "No cash refund is recorded.",
  "finance.serviceCorrection.preview": "Preview correction",
  "finance.serviceCorrection.loading": "Loading preview…",
  "finance.serviceCorrection.confirm": "Confirm correction",
  "finance.serviceCorrection.saving": "Recording correction…",
  "finance.serviceCorrection.chooseUnits": "Select the original units to reverse.",
  "finance.serviceCorrection.releaseRequired": "Enter the exact required release from the listed payments for each responsibility.",
  "finance.serviceCorrection.reasonRequired": "Enter a reason of at least three characters.",
  "finance.serviceCorrection.failed": "The correction could not be recorded. Your changes are kept.",
  "finance.serviceCorrection.periodClosed": "The posting period is closed. Reopen it before recording the correction.",
  "finance.serviceCorrection.provenanceRequired": "The original coverage evidence does not support this partial reversal.",
  "finance.serviceCorrection.sourceChanged": "The service or its financial position changed. Reload before trying again.",
  "finance.serviceCorrection.forbidden": "This action requires financial correction and clinical record write access.",
  "finance.serviceCorrection.unsaved": "The service correction has unsaved selections and a reason.",
  "finance.serviceCorrection.reload": "Reload service",
  "finance.serviceCorrection.reloadFailed": "The service could not be reloaded. Your changes are kept.",
  "finance.serviceCorrection.reloaded": "The service was reloaded. Select the remaining original units again.",
  "finance.services.priceUnavailable":
    "The current price list could not be loaded.",

  "finance.encounterServices.title": "Services",
  "finance.encounterServices.subtitle":
    "Performed services for this EMR entry and their recorded charges.",
  "finance.encounterServices.forbidden":
    "You do not have permission to read services for this EMR entry.",
  "finance.encounterServices.loading": "Loading EMR entry services",
  "finance.encounterServices.loadFailed":
    "The EMR entry services could not be loaded.",
  "finance.encounterServices.tableLabel":
    "Performed services for this EMR entry",
  "finance.encounterServices.emptyDetail":
    "Pick a service from the price list beside the table; it is recorded at quantity 1.",
  "finance.encounterServices.emptyNoRecordsDetail":
    "Save an EMR record before recording a service.",
  "finance.encounterServices.emptyNoPrimaryRecordDetail":
    "A service is billed on the entry’s current primary document, and this entry has none.",
  "finance.encounterServices.noPrimaryRecord":
    "This EMR entry has no current primary document to bill a service on.",
  "finance.encounterServices.column.record": "EMR record",
  // The record a charge is filed against, named by its document and the
  // moment it was authored. Composed here rather than in TSX: a bare
  // hyphen between a Hebrew title and a Latin timestamp is reordered by
  // the bidi algorithm, and which mark stands between them is grammar.
  "finance.encounterServices.recordName": "{document}, {authored}",
  "finance.encounterServices.billedOn": "Billed on {name}",
  "finance.encounterServices.recordUnavailable": "Unavailable record",
  "finance.encounterServices.column.actions": "Actions",

  "finance.servicePicker.title": "Medical services",
  "finance.servicePicker.catalogueTab": "Price list",
  "finance.servicePicker.searchPlaceholder": "Service name or code",
  "finance.servicePicker.loading": "Loading the price list",
  "finance.servicePicker.empty": "The price list has no services.",
  "finance.servicePicker.noMatches": "No service matches this search.",

  "finance.patient.title": "Finance",
  "finance.patient.forbidden":
    "You may not read this patient’s financial record.",
  "finance.patient.forbiddenDetail":
    "The rest of the patient card is still available.",
  "finance.menuLabel": "Finance sections",
  "finance.nav.estimates": "Estimates",
  "finance.nav.estimatesDescription":
    "Treatment cost estimates for the patient",

  "finance.evidence.original": "Original issued amount",

  "finance.correction.reason": "Correction reason",
  "finance.correction.reasonRequired": "Enter a specific correction reason.",
  "finance.correction.stale":
    "The financial evidence changed. Close and reopen this dialog to review the latest revision.",
  "finance.correction.historicalIncomplete":
    "This historical record does not contain a complete sealed snapshot and cannot be corrected safely.",
  "finance.correction.unsavedIntent": "Unsaved financial correction",

  // ——— The finance staff workspace: /finance ———
  "finance.workspace.title": "Finance",
  "finance.workspace.tileDescription": "Accounts, receipts, services and prices, the monthly close",
  "finance.workspace.areaNavigation": "Finance sections",
  "finance.nav.accounts": "Billing accounts",
  "finance.nav.accountsDescription": "Balances and money received",
  "finance.nav.people": "Financial participants",
  "finance.nav.peopleDescription": "People and organizations in financial relationships",
  "finance.nav.priceLists": "Price lists",
  "finance.nav.priceListsDescription": "What the Clinic charges for its services, by date",
  "finance.nav.taxes": "Taxes",
  "finance.nav.taxesDescription": "Dated tax terms a price can include",
  "finance.nav.externalCosts": "External costs",
  "finance.nav.externalCostsDescription": "Third-party expense catalogue for treatment estimates",
  "finance.nav.administration": "Finance settings",
  "finance.nav.administrationDescription": "The finance profile and monthly periods",
  "finance.nav.services": "Services",
  "finance.nav.servicesDescription": "What the Clinic does and what it charges today",
  "finance.clinicServices.subtitle": "Every service the Clinic names, with its price today",
  "finance.clinicServices.tableLabel": "Clinic services",
  "finance.clinicServices.column.name": "Service",
  "finance.clinicServices.column.source": "Source",
  "finance.clinicServices.column.price": "Price today",
  "finance.clinicServices.column.state": "State",
  "finance.clinicServices.actions": "Actions",
  "finance.clinicServices.openNamed": "Open {name}",
  "finance.clinicServices.priceByBranch": "Differs by branch",
  "finance.clinicServices.readOnly": "You may read the services and their prices but not change them.",
  "finance.clinicServices.loading": "Loading the services",
  "finance.clinicServices.loadFailed": "The services could not be loaded.",
  "finance.clinicServices.empty": "No services yet",
  "finance.clinicServices.emptyDetail": "Add the first service the Clinic provides. Its price is optional.",
  "finance.clinicServices.emptyDetailReader": "Nobody has named a service the Clinic provides.",
  "finance.clinicServices.noDefaultList": "Prices are not shown: the Clinic keeps several price lists and none is the default. Choose one under Price lists.",
  "finance.clinicService.title": "Clinic service",
  "finance.clinicService.new": "New service",
  "finance.clinicService.source": "Service source",
  "finance.clinicService.custom": "Named by the Clinic",
  "finance.clinicService.terminology": "From the medical service dictionary",
  "finance.clinicService.search": "Search the medical service dictionary",
  "finance.clinicService.conceptRequired": "Choose a dictionary service.",
  "finance.clinicService.conceptClear": "Clear the chosen service",
  "finance.clinicService.name": "Service name",
  "finance.clinicService.save": "Save",
  "finance.clinicService.price": "Price, {currency}",
  "finance.clinicService.newPrice": "New price from today, {currency}",
  "finance.clinicService.priceOptional": "Every branch, from today. Leave empty to save without a price; a branch's own price or a dated one is set under Price lists.",
  "finance.clinicService.priceInvalid": "Enter the price as digits, with at most {scale} decimals after the Clinic's decimal mark.",
  "finance.clinicService.priceList": "Price list",
  "finance.clinicService.priceListDefault": "{list} — default",
  "finance.clinicService.priceListEvery": "Every price list",
  "finance.clinicService.priceListHint": "The price is recorded in this list. Every price list records the same price in each of them.",
  "finance.clinicService.priceInList": "It goes into {list}.",
  "finance.clinicService.priceFirstList": "The Clinic has no price list yet: this price opens its default one.",
  "finance.clinicService.priceListFailed": "The price was not recorded in {list}.",
  "finance.clinicService.tax": "Tax",
  "finance.clinicService.noTax": "No tax",
  "finance.clinicService.history": "Prices",
  "finance.clinicService.historyLoading": "Loading the prices",
  "finance.clinicService.historyLoadFailed": "The prices could not be loaded.",
  "finance.clinicService.historyEmpty": "No price has been set.",
  "finance.clinicService.pricesInList": "Prices of {name} in {list}",
  "finance.clinicService.pastPricesInList": "Past prices of {name} in {list}",
  "finance.clinicService.pastPrices": "Past prices",
  "finance.clinicService.noCurrentPrices": "No price is in force today.",
  "finance.clinicService.priceSince": "From {from}",
  "finance.clinicService.priceBetween": "From {from} until {until}",
  "finance.clinicService.allBranches": "All branches",
  "finance.clinicService.rowLive": "Current",
  "finance.clinicService.rowFuture": "Upcoming",
  "finance.clinicService.rowEnded": "Ended",
  "finance.clinicService.rowRetracted": "Retracted",
  "finance.clinicService.retractNamed": "Retract the price {price} from {from}",
  "finance.clinicService.retractTitle": "Retract this price?",
  "finance.clinicService.retractDescription": "The price {price} from {from} will count as never set; the prices it replaced apply again. Issued estimates keep the price they were issued at.",
  "finance.clinicService.retractConfirm": "Retract",
  "finance.clinicService.keepPrice": "Keep the price",
  "finance.clinicService.active": "Active",
  "finance.clinicService.archived": "Archived",
  "finance.clinicService.archive": "Archive",
  "finance.clinicService.restore": "Restore",
  "finance.clinicService.unsavedName": "an unsaved service name",
  "finance.clinicService.unsaved": "an unsaved clinic service",
  "finance.clinicService.unsavedPrice": "an unsaved service price",
  "finance.clinicService.discard": "Discard changes",
  "finance.clinicService.reloadDiscard": "Reload and discard changes",
  "finance.clinicService.saveFailed": "The service could not be saved.",
  "finance.clinicService.codeConflict": "A service with this code already exists.",
  "finance.clinicService.revisionConflict": "The clinic service changed while you were editing. Reload before saving.",
  "finance.clinicService.suggestionStale": "The suggestions were made for an older name. Request them again.",
  "finance.clinicService.notFound": "This service no longer exists.",
  "finance.clinicService.archivedRefusal": "An archived service cannot be changed. Restore it first.",
  "finance.clinicService.invalid": "The service was refused. Check the name and the price.",
  "finance.clinicService.dictionaryFailed": "The service dictionary could not be loaded.",
  "finance.clinicService.dictionaryUnavailable": "The Clinic's service dictionary is not answering. Check the clinic's terminology bindings.",
  "finance.clinicService.changed": "The service or its prices changed meanwhile. Reload before saving.",
  "finance.clinicService.listArchived": "The default price list is archived. Restore it or choose another default under Price lists.",
  "finance.clinicService.listUnavailable": "The Clinic keeps several price lists and none is the default. Choose one under Price lists.",
  "finance.clinicService.priceNotFound": "This price no longer exists. Reload.",
  "finance.clinicService.priceRetracted": "This price was already retracted.",

  "finance.party.loading": "Loading name",
  "finance.party.unavailable": "Name unavailable",
  "finance.party.peopleGroup": "People",
  "finance.party.entitiesGroup": "Legal entities",

  "finance.accounts.title": "Billing accounts",
  "finance.accounts.tableLabel": "Billing accounts",
  "finance.accounts.columnOwner": "Owner",
  "finance.accounts.columnLifecycle": "Lifecycle",
  "finance.accounts.columnCurrency": "Currency",
  "finance.accounts.columnCreated": "Opened",
  "finance.accounts.lifecycleActive": "Active",
  "finance.accounts.lifecycleArchived": "Archived",
  "finance.accounts.lifecycleClosed": "Closed",
  "finance.accounts.loading": "Loading billing accounts",
  "finance.accounts.empty": "No billing accounts yet",
  "finance.accounts.emptyDetail": "The first account is opened from the button above.",
  "finance.accounts.noMatches": "No accounts match",
  "finance.accounts.noMatchesDetail": "Change or clear the narrowing to see more accounts.",
  "finance.accounts.ownerFilter": "Narrow by owner",
  "finance.accounts.ownerAny": "Any owner",
  "finance.accounts.ownerNarrowed": "Owner: {name}",
  "finance.accounts.ownerNarrowedClear": "Show every owner",
  "finance.accounts.createTitle": "Open a billing account",
  "finance.accounts.createDetail":
    "One account per owner, in the currency the finance profile fixes.",
  "finance.accounts.createSubmit": "Open account",
  "finance.accounts.createSubmitting": "Opening",
  "finance.accounts.ownerField": "Owner",
  "finance.accounts.ownerPlaceholder": "Search people and legal entities",
  "finance.accounts.ownerRequired": "Choose the account's owner.",
  "finance.accounts.createUnsaved": "an unopened billing account",
  "finance.accounts.createUnsavedDetail": "The chosen owner will be discarded.",
  "finance.accounts.failed": "The billing-account request could not be completed.",
  "finance.accounts.exists":
    "This party already has a billing account. Open the existing account instead.",
  "finance.accounts.conflict":
    "The account changed while you were working. Read it again and retry.",
  "finance.accounts.stateConflict": "The account's lifecycle does not allow this action.",
  "finance.accounts.profileUnconfigured":
    "The finance profile is not configured yet. Configure it under Finance administration first.",
  "finance.accounts.attemptConflict":
    "This attempt was already sent with different details. Close the form and start again.",
  "finance.accounts.forbidden": "You do not have permission for this billing-account action.",
  "finance.accounts.invalid": "Check the entered details.",

  "finance.account.title": "Billing account",
  "finance.account.loading": "Loading the account",
  "finance.account.loadFailed": "The account could not be loaded.",
  "finance.account.factsLabel": "Account facts",
  "finance.account.changeLifecycle": "Change lifecycle",
  "finance.account.positionTitle": "Position",
  "finance.account.positionLoading": "Calculating the position",
  "finance.account.positionFailed": "The position could not be calculated.",
  "finance.account.positionAsOf": "As of {date}",
  "finance.account.bucketReceivable": "Receivable",
  "finance.account.bucketPendingConfirmation": "Pending confirmation",
  "finance.account.bucketDisputed": "Disputed",
  "finance.account.bucketAvailableFunds": "Available funds",
  "finance.account.bucketPrepaidValue": "Prepaid value",
  "finance.account.lifecycleTitle": "Change the account lifecycle",
  "finance.account.lifecycleDetail": "Say where this account stands now, and why.",
  "finance.account.lifecycleField": "New lifecycle",
  "finance.account.lifecycleSubmit": "Change lifecycle",
  "finance.account.lifecycleSubmitting": "Changing",
  "finance.account.lifecycleUnsaved": "an unsent lifecycle change",
  "finance.account.reasonField": "Reason",
  "finance.account.reasonRequired": "State the reason.",

  "finance.receipts.title": "Receipts",
  "finance.receipts.tableLabel": "Receipts",
  "finance.receipts.record": "Record receipt",
  "finance.receipts.columnCashDate": "Cash date",
  "finance.receipts.columnRemitter": "Remitter",
  "finance.receipts.columnMethod": "Method",
  "finance.receipts.columnAmount": "Amount",
  "finance.receipts.columnAvailable": "Available",
  "finance.receipts.columnRecorded": "Recorded",
  "finance.receipts.loading": "Loading receipts",
  "finance.receipts.loadFailed": "The receipts could not be loaded.",
  "finance.receipts.empty": "No receipts yet",
  "finance.receipts.emptyDetail": "Money received onto this account will stand here.",
  "finance.receipts.methodCash": "Cash",
  "finance.receipts.methodCard": "Card",
  "finance.receipts.methodBankTransfer": "Bank transfer",
  "finance.receipts.methodOther": "Other",
  "finance.receipts.recordTitle": "Record a receipt",
  "finance.receipts.recordDetail": "Money received onto this account, exactly as taken.",
  "finance.receipts.recordSubmit": "Record receipt",
  "finance.receipts.recordSubmitting": "Recording",
  "finance.receipts.remitterField": "Remitter",
  "finance.receipts.remitterPlaceholder": "Search people and legal entities",
  "finance.receipts.remitterRequired": "Choose who remitted the money.",
  "finance.receipts.amountField": "Amount",
  "finance.receipts.amountRequired": "Type the amount received.",
  "finance.receipts.methodField": "Method",
  "finance.receipts.branchField": "Receiving branch",
  "finance.receipts.branchRequired": "Choose the receiving branch.",
  "finance.receipts.branchesFailed": "The branches could not be loaded.",
  "finance.receipts.cashDateField": "Cash date",
  "finance.receipts.evidenceField": "Evidence reference",
  "finance.receipts.evidenceRequired":
    "Name the receipt's evidence — a slip, transfer or register reference.",
  "finance.receipts.reasonField": "Reason",
  "finance.receipts.reasonRequired": "State the reason.",
  "finance.receipts.unsavedIntent": "an unrecorded receipt",
  "finance.receipts.unsavedDetail": "The typed receipt will be discarded.",
  "finance.receipts.reload": "Read the account again",
  "finance.receipts.reloadFailed": "The account could not be read again.",
  "finance.receipts.reloaded":
    "The account was read again. Check the draft, then send it.",
  "finance.receipts.digestTitle": "Receipt",
  "finance.receipts.postingDate": "Posting date",
  "finance.receipts.journalTransaction": "Journal transaction",
  "finance.receipts.evidenceDigest": "Evidence digest",
  "finance.receipts.beneficiaryRestricted":
    "Restricted to one patient's benefit.",
  "finance.receipts.failed": "The receipt could not be recorded.",
  "finance.receipts.conflict":
    "The account changed while you were working. Read it again, then send the receipt.",
  "finance.receipts.accountStateConflict":
    "Receipts can be recorded only onto an active account.",
  "finance.receipts.periodClosed":
    "The financial period of that cash date is closed. Reopen it under Finance administration or choose another date.",
  "finance.receipts.amountInvalid":
    "The amount could not be read. Type it in the clinic's number format.",
  "finance.receipts.amountOverflow": "The amount is too large.",
  "finance.receipts.currencyMismatch":
    "The amount's currency does not match the account's.",
  "finance.receipts.attemptConflict":
    "This attempt was already sent with different details. Close the form and start again.",
  "finance.receipts.forbidden": "You do not have permission to record receipts.",
  "finance.receipts.invalid": "Check the entered receipt details.",

  "finance.people.title": "Financial participants",
  "finance.people.tableLabel": "Financial participants",
  "finance.people.loading": "Loading financial participants",
  "finance.people.empty": "No financial participants yet",
  "finance.people.emptyDetail":
    "Add an existing person or organization, or register a new identity.",
  "finance.people.noMatches": "No people match",
  "finance.people.noMatchesDetail": "Change the search to see more people.",
  "finance.people.registerTitle": "Register a financial person",
  "finance.people.registerDetail":
    "Someone who owns accounts or remits money, named in their own language.",
  "finance.people.registerSubmit": "Register",
  "finance.people.registerSubmitting": "Registering",
  "finance.people.registerUnsaved": "an unregistered financial person",
  "finance.people.registerUnsavedDetail": "The typed names will be discarded.",
  "finance.people.reasonField": "Reason",
  "finance.people.reasonRequired": "State the reason.",
  "finance.people.languageField": "Primary language",
  "finance.people.participationTitle": "Participation",
  "finance.people.participationFailed": "The participation could not be loaded.",
  "finance.people.participationUnsaved": "an unsent participation change",
  "finance.people.active": "Participating",
  "finance.people.withdrawn": "Withdrawn",
  "finance.people.withdraw": "Withdraw",
  "finance.people.reinstate": "Reinstate",
  "finance.people.namesTitle": "Names",
  "finance.people.namesLoading": "Loading names",
  "finance.people.namesFailed": "The names could not be loaded.",
  "finance.people.namesUnsaved": "unsaved name changes",
  "finance.people.reload": "Read again",
  "finance.people.reloadFailed": "Could not read again.",
  "finance.people.reloaded": "Read again. Check the draft, then save.",
  "finance.people.failed": "The financial-person request could not be completed.",
  "finance.people.conflict":
    "This person's record changed while you were working. Read it again and retry.",
  "finance.people.attemptConflict":
    "This attempt was already sent with different details. Close the form and start again.",
  "finance.people.forbidden":
    "You do not have permission for this action on financial persons.",
  "finance.people.invalid": "Check the entered details.",

  "finance.administration.title": "Finance settings",
  "finance.administration.profileTitle": "Finance profile",
  "finance.administration.profileLoading": "Loading the profile",
  "finance.administration.profileLoadFailed": "The profile could not be loaded.",
  "finance.administration.unconfigured":
    "The finance profile is not configured. No account can be opened and no money recorded until it is.",
  "finance.administration.unconfiguredDetail":
    "Configuration needs profile-management authority.",
  "finance.administration.configure": "Configure profile",
  "finance.administration.configureTitle": "Configure the finance profile",
  "finance.administration.configureDetail":
    "The clinic's currency and the day it takes effect.",
  "finance.administration.configureSubmit": "Configure",
  "finance.administration.configureSubmitting": "Configuring",
  "finance.administration.configureUnsaved": "an unsent profile configuration",
  "finance.administration.configureUnsavedDetail":
    "The typed configuration will be discarded.",
  "finance.administration.currency": "Currency",
  "finance.administration.currencyField": "Currency",
  "finance.administration.currencyRequired": "Choose the currency.",
  "finance.administration.currenciesFailed": "The currency catalogue could not be loaded.",
  "finance.administration.effectiveFrom": "Effective from",
  "finance.administration.effectiveFromField": "Effective from",
  "finance.administration.effectiveFromRequired":
    "Choose the day the profile takes effect.",
  "finance.administration.reasonField": "Reason",
  "finance.administration.reasonRequired": "State the reason.",
  "finance.administration.operatingEntity": "Operating legal entity",
  "finance.administration.recordedAt": "Recorded",
  "finance.administration.reload": "Read again",
  "finance.administration.reloadFailed": "Could not read again.",
  "finance.administration.reloaded": "Read again. Check the standing, then retry.",
  "finance.administration.profileFailed": "The profile could not be saved.",
  "finance.administration.profileUnconfigured": "No profile covers that date.",
  "finance.administration.profileConflict":
    "The profile changed while you were configuring. Read it again and check the revision in force.",
  "finance.administration.currencyLocked":
    "The clinic's currency is already locked by recorded money and cannot change.",
  "finance.administration.attemptConflict":
    "This attempt was already sent with different details. Close the form and start again.",
  "finance.administration.profileForbidden":
    "You do not have permission to manage the finance profile.",
  "finance.administration.profileInvalid": "Check the entered configuration.",
  "finance.administration.periodsTitle": "Financial periods",
  "finance.administration.monthField": "Month",
  "finance.administration.periodLoading": "Loading the period",
  "finance.administration.periodLoadFailed": "The period could not be loaded.",
  "finance.administration.open": "This month is open — money can be recorded into it.",
  "finance.administration.closed":
    "This month is closed — no money can be recorded into it.",
  "finance.administration.changedAt": "Last change {time}.",
  "finance.administration.closePeriod": "Close the month",
  "finance.administration.reopenPeriod": "Reopen the month",
  "finance.administration.periodUnsaved": "an unsent period change",
  "finance.administration.periodFailed": "The period could not be changed.",
  "finance.administration.periodConflict":
    "The period changed while you were working. Read it again and retry.",
  "finance.administration.periodStateConflict": "The period already stands that way.",
  "finance.administration.periodForbidden":
    "You do not have permission to close or reopen periods.",
  "finance.administration.periodInvalid": "Check the entered details.",
  "finance.serviceEntry.date": "Service date",
  "finance.serviceEntry.postingDate": "Posting date",
  "finance.serviceEntry.list": "Price list",
  "finance.serviceEntry.chooseList": "Choose a price list",
  "finance.serviceEntry.account": "Billing account",
  "finance.serviceEntry.chooseAccount": "Choose the billing account",
  "finance.serviceEntry.accountMissing": "No active billing account for this patient. Ask a financial operator to open one.",
  "finance.serviceEntry.chooseService": "Choose a price list and service.",
  "finance.serviceEntry.dateQuantityRequired": "Enter a service date and a quantity from 1 to 100.",
  "finance.serviceEntry.reason": "Service confirmation note",
  "finance.serviceEntry.reasonRequired": "Enter a confirmation note of at least 3 characters.",
  "finance.serviceEntry.preview": "Review charge",
  "finance.serviceEntry.confirm": "Confirm service and charge",
  "finance.serviceEntry.loading": "Calculating charge…",
  "finance.serviceEntry.saving": "Recording service…",
  "finance.serviceEntry.gross": "Charge including tax",
  "finance.serviceEntry.net": "Charge before tax",
  "finance.serviceEntry.tax": "Included tax",
  "finance.serviceEntry.unsaved": "an unconfirmed service and charge",
  "finance.serviceEntry.failed": "The service could not be recorded. Your entries are kept.",
  "finance.serviceEntry.profileMissing": "The clinic financial profile has not been configured.",
  "finance.serviceEntry.periodClosed": "The service-date financial period is closed.",
  "finance.serviceEntry.currencyMismatch": "The selected price list and account use different currency definitions.",
  "finance.serviceEntry.changed": "The record, account or price publication changed. Reload before confirming.",
  "finance.serviceEntry.forbidden": "You do not have permission to record clinical services and charges.",
  "finance.serviceEntry.unavailable": "The selected service source or account is unavailable.",
  "finance.serviceEntry.contextFailed": "Service entry details could not be loaded.",
  "finance.serviceEntry.serviceUnavailable": "This service is not on the selected price list.",
  "finance.serviceEntry.reload": "Reload entry details",
  "finance.serviceEntry.reloadFailed": "Reload failed. Your entries are kept.",
  "finance.serviceEntry.reloaded": "Current details loaded. Select and confirm the service again.",
  "finance.prepaidEntry.mode": "Service payment",
  "finance.prepaidEntry.selfPay": "New charge",
  "finance.prepaidEntry.prepaid": "Prepaid units",
  "finance.prepaidEntry.title": "Use prepaid services",
  "finance.prepaidEntry.available": "Available purchased units",
  "finance.prepaidEntry.chooseRange": "Choose a purchased range",
  "finance.prepaidEntry.choice": "{service} · purchased {date} · {range} · {price} per unit",
  "finance.prepaidEntry.range": "Units {first}–{last}",
  "finance.prepaidEntry.first": "First original unit",
  "finance.prepaidEntry.add": "Add selected units",
  "finance.prepaidEntry.remove": "Remove selected range",
  "finance.prepaidEntry.more": "More available units",
  "finance.prepaidEntry.empty": "No available prepaid units for this patient.",
  "finance.prepaidEntry.chooseUnits": "Select original purchased units for this service.",
  "finance.prepaidEntry.addPending": "Add the chosen units or clear the range selection.",
  "finance.prepaidEntry.preview": "Review prepaid use",
  "finance.prepaidEntry.confirm": "Confirm prepaid service",
  "finance.prepaidEntry.loading": "Checking purchased units…",
  "finance.prepaidEntry.gross": "Purchased value used",
  "finance.prepaidEntry.net": "Purchased value before tax",
  "finance.prepaidEntry.unsaved": "an unconfirmed prepaid service",
  "finance.prepaidEntry.failed": "The prepaid service could not be recorded. Your entries are kept.",
  "finance.prepaidEntry.readFailed": "Available purchased units could not be loaded.",
  "finance.prepaidEntry.periodClosed": "A required financial posting period is closed.",
  "finance.prepaidEntry.currencyMismatch": "The purchase uses a different currency definition from the clinic profile.",
  "finance.prepaidEntry.unitsUnavailable": "Selected units have been used or returned. Reload availability.",
  "finance.prepaidEntry.notActive": "This purchase is not fully funded and active.",
  "finance.prepaidEntry.changed": "The record, purchase or source account changed. Reload before confirming.",
  "finance.prepaidEntry.forbidden": "You do not have permission to record clinical services using prepaid units.",
  "finance.prepaidEntry.unavailable": "The selected purchase or clinical source is unavailable.",
  "finance.prepaidCorrection.title": "Correct prepaid service",
  "finance.prepaidCorrection.gross": "Value restored to the purchase",
  "finance.prepaidCorrection.net": "Restored value before tax",
  "finance.prepaidCorrection.restored": "Restored purchase units",
  "finance.prepaidCorrection.keepOnRecord": "Confirm retained services on this current record:",
  "finance.prepaidCorrection.confirmRetention": "Confirm the current record for the retained services.",
  "finance.prepaidCorrection.currentRecordRequired": "A current primary record is required to retain services. A full reversal needs no replacement record.",
  "finance.prepaidCorrection.noPayout": "Removed units become available in the original purchase. No money is paid out.",
  "finance.prepaidCorrection.sourceChanged": "The original service, purchase or source account changed. Reload before confirming.",
  "finance.prepaidCorrection.unsaved": "an unconfirmed prepaid service correction",
  "finance.participants.name": "Name",
  "finance.participants.person": "Person",
  "finance.participants.organization": "Organization",
  "finance.participants.openIdentity": "Open identity card",
  "finance.participants.accounts": "Billing accounts",
  "finance.participants.noAccounts": "No billing accounts yet.",
  "finance.participants.openAccount": "Open account",
  "finance.participants.account": "Account in {currency}",
  "finance.participants.positionFailed": "The account balances could not be loaded.",
  "finance.participants.add": "Add financial participant",
  "finance.participants.unsaved": "an unsaved financial participant",
  "finance.participants.newPerson": "Register a new person",
  "finance.participants.newOrganization": "Register a new organization",
  "finance.participants.back": "Back to financial participants",
  "finance.participants.openPatient": "Open patient card",
  "finance.participants.staffIdentity": "Staff identity; changes require staff identity permissions.",
  "finance.participants.identityRestricted": "Personal details are managed through the existing role with its own permissions.",
  "finance.permissions.title": "Permitted to pay for",
  "finance.permissions.loading": "Loading payment permission",
  "finance.permissions.failed": "Payment permissions could not be loaded.",
  "finance.permissions.empty": "No permissions to pay for other patients.",
  "finance.permissions.allowed": "The account owner has permitted payment for this patient.",
  "finance.permissions.required": "The account owner must permit payment for this patient before funds can be used.",
  "finance.permissions.manage": "Open account permissions",
  "finance.permissions.add": "Record owner permission",
  "finance.permissions.more": "Show more",
  "finance.permissions.patientUnavailable": "Patient identity unavailable",
  "finance.permissions.active": "Active",
  "finance.permissions.revoked": "Revoked",
  "finance.permissions.revoke": "Revoke permission",
  "finance.permissions.reason": "Reason and basis",
  "finance.permissions.document": "Supporting document {number}",
  "finance.permissions.documentFailed": "The supporting documents could not be read.",
  "finance.permissions.documents": "Supporting documents (optional)",
  "finance.permissions.upload": "Attach signed statement or supporting files",
  "finance.permissions.ownerStatement": "Record the account owner’s explicit permission to pay for the selected patient. Family relationship alone does not grant permission.",
  "finance.permissions.patient": "Patient to pay for",
  "finance.permissions.save": "Record permission",
  "finance.permissions.unsaved": "an unsaved payment permission",
  "finance.permissions.discard": "Discard the unsaved information? Uploaded documents remain in the identity’s files.",
  "finance.settlement.sourceOwner": "Pay from account of",
  "finance.settlement.sourceAccount": "Source account",
  "finance.participants.patientAccount": "Patient’s account",
  "finance.permissions.exists": "An active payment permission already exists for this patient.",
  "finance.permissions.accountInactive": "The source account is not active.",
  "finance.permissions.unavailable": "The account, patient or permission is no longer available.",
} as const;
